<template>
      <b-row class="js-masonry-init">
        <div v-show="loading" class="loading">
              <loading-panel></loading-panel>
        </div>
        <b-col v-show="!loading" class="js-masonry-item" xs="12" md="6" v-for="(item,index) in collections" :key="index">
          <b-card no-body class="card-article">
            <!-- Card image -->
            <div :class="'card-img-top' + itemImageClass(item)" v-if="item.image">
              <a :href="item.id" @click="loadCollectionPage($event)">
                <img :src="item.image.absoluteUri" :alt="item.img_alt" v-if="item.image">
              </a>
            </div>
            <div class="card-img-top" v-bind:style="{ background: item.colorChoice, height: '80px' }" v-else>
              
            </div>
            <!-- Card body -->
            <b-card-body>
              <div class="card-badge">
                <p>
                  <strong>{{ item.recipeCount }}</strong>
                  Recipes
                </p>
              </div><!-- /.card-badge -->
              <b-card-title class="h2 mb-0">
                <a :href="item.id" @click="loadCollectionPage($event)">{{ item.title }}</a>
              </b-card-title>
              <!--small class="text-muted">{{ authorBy }} {{ item.author }}, {{ item.date_created }}</small-->
              <b-card-text class="mt-4 js-truncate-summary" v-html="item.description"></b-card-text>
              <div class="d-flex justify-content-between align-items-center">
                <router-link
                  to="/collections"
                >
                  <a class="btn btn-link px-0">{{ viewButton }}</a>
                </router-link>
                <!-- <a :href="item.id" class="btn btn-link px-0" @click="loadCollectionPage($event)">{{ viewButton }}</a> -->

                <div class="icon-actions">
                  <a href="#" class="like active" @click="handleLike($event, index, item)">
                    <i class="ni ni-like-2"></i>
                    <span class="text-muted">{{ item.likes }}</span>
                  </a>
                  <a href="#">
                    <i class="ni ni-chat-round"></i>
                    <span class="text-muted">{{ item.comments }}</span>
                  </a>
                  <a href="#">
                    <i class="ni ni-curved-next"></i>
                    <span class="text-muted">{{ item.shares }}</span>
                  </a>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
import Masonry from 'masonry-layout';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      propsToSearch: ['title', 'description', 'brand'],
      data: null,
      itemLimit: '10',
      view: 'table',
      loading: false
    };
  },
  computed: {
    title() {
      return this.data && this.data.pages.collections.title;
    },
    apiKey() {
      return this.data && this.data.api_key;
    },
    collections() {
      return Object.values(this.$store.state.collections.all.results);
      //return this.data && this.data.collections.items;
    },
    recipes() {
      return this.data && this.data.recipes.items;
    },
    authorBy() {
      return this.data && this.data.collections.author_by;
    },
    viewButton() {
      return this.data && this.data.collections.view_button;
    },
    isLoading() {
      return this.$store.state.collections.loading
    }
  },
  methods: {
    countCollections(recipes) {
      return 100;
      //return collections.length;
    },
    handleLike(event, index, item) {
      event.preventDefault();

      const likeButton = event.target.closest('.like');

      if (likeButton) {
        likeButton.classList.contains('active') ? item.likes-- : item.likes++;
        likeButton.classList.toggle('active');
      }
    },
    itemImageClass(element) {
      return element.img_class ? ' card-img-top--' + element.img_class : '';
    },
    initMasonry() {
      const grid = document.querySelector('.js-masonry-init');
      const options = {
        columnWidth: '.js-masonry-item',
        itemSelector: '.js-masonry-item',
        percentPosition: true
      }

      let msnry = new Masonry(grid, options)
    },
    loadCollectionPage(event) {
      event.preventDefault();

      let route = 'collection';
      const button = event.target.closest('a');

      if (button) {
        this.$router.push({
          name: 'Collection',
          params: { 
            id: button.getAttribute('href')
          }
        }).catch(() => {});
      }
    }
  },
  created() {
    const { dispatch } = this.$store;
    dispatch("collections/getAllCollections");
  },
  mounted() {
    setTimeout(() => {
      this.initMasonry();
    }, 1000)
  },
  updated() {
    setTimeout(() => {
      this.initMasonry();
    }, 1000);
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    }
  }
};
</script>
<style></style>
